import React, { useContext } from 'react';
import { GenericAuthContext } from '../../authContexts';
import Center from '@components/common/alignment/Center';
import ErrorPage from '@components/common/Error';
import AnnouncementStream from '@components/common/announcement/AnnouncementStream';
import ContentBox from '@components/common/ContentBox';

const AnnouncementsDashboard: React.FC = () => {
  const { userDoc } = useContext(GenericAuthContext);
  const userData = userDoc.data();

  if (!userData) {
    return <ErrorPage></ErrorPage>;
  }

  return (
    <Center>
      <p className='font-raleway font-bold text-coffee text-5xl m-8 text-center'>
        WELCOME, {userData.static.firstName.toUpperCase()}!
      </p>
      <ContentBox>
        <AnnouncementStream></AnnouncementStream>
      </ContentBox>
    </Center>
  );
};

export default AnnouncementsDashboard;
